import React from "react";
import "./Mobilebar.css";
import Logo from "../../assets/images/logo.png";
import { Link } from "react-router-dom";

const Mobilebar = () => {
  return (
    <div className="mobilebar__wrapper">
      <nav className="mobile__bar">
        <input
          type="checkbox"
          id="menu"
          name="menu"
          className="m-menu__checkbox"
        />
        <label className="m-menu__toggle" htmlFor="menu">
          <svg
            width="35"
            height="35"
            viewBox="0 0 24 24"
            fill="none"
            stroke="#2cb3b9"
            strokeWidth="2"
            strokeLinecap="butt"
            strokeLinejoin="arcs"
          >
            <line x1="3" y1="12" x2="21" y2="12"></line>
            <line x1="3" y1="6" x2="21" y2="6"></line>
            <line x1="3" y1="18" x2="21" y2="18"></line>
          </svg>
        </label>
        <label className="m-menu__overlay" htmlFor="menu"></label>
        <Link to="/" className="mobile__bar_logowrap">
          <img src={Logo} alt="" className="mobile__bar_logo" />
        </Link>
        <div className="m-menu">
          <div className="m-menu__header">
            <label className="m-menu__toggle" htmlFor="menu">
              <svg
                width="35"
                height="35"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#000000"
                strokeWidth="2"
                strokeLinecap="butt"
                strokeLinejoin="arcs"
              >
                <line x1="18" y1="6" x2="6" y2="18"></line>
                <line x1="6" y1="6" x2="18" y2="18"></line>
              </svg>
            </label>
            <span>Menu</span>
          </div>
          <ul>
            <li>
              <Link to="/about">About Us</Link>
            </li>
            <li>
              <Link to="/why-serene">Why Serene</Link>
            </li>
            <li>
              <label className="a-label__chevron" htmlFor="item-2">
                Services
              </label>
              <input
                type="checkbox"
                id="item-2"
                name="item-2"
                className="m-menu__checkbox"
              />
              <div className="m-menu">
                <div className="m-menu__header">
                  <label className="m-menu__toggle" htmlFor="item-2">
                    <svg
                      width="35"
                      height="35"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="#000000"
                      strokeWidth="2"
                      strokeLinecap="butt"
                      strokeLinejoin="arcs"
                    >
                      <path d="M19 12H6M12 5l-7 7 7 7" />
                    </svg>
                  </label>
                  <span>Services</span>
                </div>
                <ul>
                  <li>
                    <label className="a-label__chevron" htmlFor="item-2-3">
                      Individual Services
                    </label>
                    <input
                      type="checkbox"
                      id="item-2-3"
                      name="item-2"
                      className="m-menu__checkbox"
                    />
                    <div className="m-menu">
                      <div className="m-menu__header">
                        <label className="m-menu__toggle" htmlFor="item-2-3">
                          <svg
                            width="35"
                            height="35"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="#000000"
                            strokeWidth="2"
                            strokeLinecap="butt"
                            strokeLinejoin="arcs"
                          >
                            <path d="M19 12H6M12 5l-7 7 7 7" />
                          </svg>
                        </label>
                        <span> Individual Services </span>
                      </div>
                      <ul>
                        <li>
                          <Link to="/tax-planning-service">
                            Advance Tax Planning
                          </Link>
                        </li>
                        <li>
                          <Link to="/tax-returns-service">
                            Preparation of Federal and State Tax Returns
                          </Link>
                        </li>
                        <li>
                          <Link to="/irs-audit-service">
                            Filing of Amendment Tax Returns/ Claim for refund
                          </Link>
                        </li>
                        <li>
                          <Link to="itin-service">
                            Preparation of ITIN (Form W7) applications
                          </Link>
                        </li>
                        <li>
                          <Link to="/extension-service">
                            Extension of Tax Returns
                          </Link>
                        </li>
                        <li>
                          <Link to="/payroll-service">Payroll Services</Link>
                        </li>
                      </ul>
                    </div>
                  </li>
                  <li>
                    <label className="a-label__chevron" htmlFor="item-3-3">
                      Resources
                    </label>
                    <input
                      type="checkbox"
                      id="item-3-3"
                      name="item-3"
                      className="m-menu__checkbox"
                    />
                    <div className="m-menu">
                      <div className="m-menu__header">
                        <label className="m-menu__toggle" htmlFor="item-3-3">
                          <svg
                            width="35"
                            height="35"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="#000000"
                            strokeWidth="2"
                            strokeLinecap="butt"
                            strokeLinejoin="arcs"
                          >
                            <path d="M19 12H6M12 5l-7 7 7 7" />
                          </svg>
                        </label>
                        <span>Resources </span>
                      </div>
                      <ul>
                        <li>
                          <Link to="/fbar-service">
                            FBAR – Foreign Bank Account Reporting
                          </Link>
                        </li>
                        <li>
                          <Link to="/fatca-service">
                            Foreign Account Tax Compliance Act (FATCA Form 8938)
                          </Link>
                        </li>
                        <li>
                          <Link to="/alien-service">Non-resident Alien</Link>
                        </li>
                      </ul>
                    </div>
                  </li>
                  <li>
                    <Link to="#">Business Services</Link>
                  </li>
                  {/* Add other items here if needed */}
                </ul>
              </div>
            </li>
            <li>
              <Link to="/pricing">Pricing</Link>
            </li>
            <li>
              <Link to="/contact-us">Contact</Link>
            </li>
            <li>
              <Link to="/login">Login/Register</Link>
            </li>
          </ul>
        </div>
      </nav>
    </div>
  );
};

export default Mobilebar;
